import { Box, Button, Typography } from '@mui/material';
import { Component, ErrorInfo, ReactNode } from 'react';
import { WithTranslation, withTranslation } from 'react-i18next';

interface Props extends WithTranslation {
  children: ReactNode;
}

interface State {
  hasError: boolean;
}

class ErrorBoundaryBase extends Component<Props, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error('ErrorBoundary caught:', error, info.componentStack);
  }

  render() {
    const { t } = this.props;

    if (this.state.hasError) {
      return (
        <Box
          alignItems="center"
          display="flex"
          flexDirection="column"
          gap={2}
          justifyContent="center"
          minHeight="60vh"
        >
          <Typography variant="h6">{t('errorBoundary.title')}</Typography>
          <Typography color="text.secondary" variant="body2">
            {t('errorBoundary.description')}
          </Typography>
          <Button variant="contained" onClick={() => window.location.reload()}>
            {t('errorBoundary.reloadButton')}
          </Button>
        </Box>
      );
    }

    return this.props.children;
  }
}

export const ErrorBoundary = withTranslation()(ErrorBoundaryBase);
